import { findIndex, isObject } from 'lodash';
import { actions as layout } from './layout';
import svc from 'svc';



export const types = {
	SET_STATE: 'ACCOUNTING/SET_STATE',
	RESET_ALL: 'ACCOUNTING/RESET_ALL',
	RESET_PROPERTY: 'ACCOUNTING/RESET_PROPERTY',
};

export const initialState = {
	loadType: '',
	rows: null,
	columns: [
		{ name: 'DocNum', title: 'Doc No.' },
		{ name: 'DocDate', title: 'Doc Date' },
		{ name: 'CardName', title: 'Customer Name' },
		{ name: 'CardCode', title: 'Customer Code' },
		{ name: 'SalesPerson', title: 'Sales Employee' },
		{ name: 'DocTax', title: 'Item Tax' },
		{ name: 'FreightCharge', title: 'Freight' },
		{ name: 'FreightTax', title: 'Freight Tax' },
		{ name: 'DocTotal', title: 'Doc Total' },
		{ name: 'U_WebSrc', title: 'Web Source' },
		{ name: 'issueCount', title: 'Issues' },
	],
	columnOrder: [
		'DocNum', 'DocDate', 'CardName', 'CardCode', 'SalesPerson',
		'DocTax', 'FreightCharge', 'FreightTax', 'DocTotal',
		'U_WebSrc', 'issueCount',
	],
	columnWidths: [
		{ columnName: 'DocNum', width: 100 },
		{ columnName: 'DocDate', width: 100 },
		{ columnName: 'CardName', width: 200 },
		{ columnName: 'CardCode', width: 150 },
		{ columnName: 'SalesPerson', width: 180 },
		{ columnName: 'DocTax', width: 100 },
		{ columnName: 'FreightCharge', width: 100 },
		{ columnName: 'FreightTax', width: 100 },
		{ columnName: 'DocTotal', width: 150 },
		{ columnName: 'U_WebSrc', width: 150 },
		{ columnName: 'issueCount', width: 80 },
	],
	lineColumns: [
		{ name: 'Key', title: 'Line No.' },
		{ name: 'Item', title: 'Item #' },
		{ name: 'LineStatus', title: 'Status' },
		{ name: 'U_Backordered', title: 'Backordered' },
		{ name: 'ItemName', title: 'Description' },
		{ name: 'Qty', title: 'Quantity' },
		{ name: 'Price', title: 'Price Each' },
		{ name: 'WhsCode', title: 'Whs' },
		{ name: 'LineTotal', title: 'Pre-Tax Total' },
		{ name: 'LineTax', title: 'Line Tax' },
		{ name: 'TotalAfterTax', title: 'Total' },
		{ name: 'TaxCode', title: 'Tax Code' },
	],
	lineColumnOrder: [
		'Key', 'Item', 'LineStatus', 'U_Backordered', 'ItemName', 'Qty',
		'Price', 'WhsCode', 'LineTax', 'LineTotal',
		'TotalAfterTax', 'TaxCode',
	],
	freightColumns: [
		{ name: 'FreightCode', title: 'Freight Code' },
		{ name: 'FreightName', title: 'Freight Name' },
		{ name: 'Status', title: 'Freight Line Status' },
		{ name: 'FreightTotal', title: 'Pre-Tax Total' },
		{ name: 'FreightTax', title: 'Tax' },
		{ name: 'TotalAfterTax', title: 'Total' },
		{ name: 'TaxCode', title: 'Tax Code' },
	],
	freightColumnOrder: [
		'FreightCode', 'FreightName', 'Status', 'FreightTotal',
		'FreightTax', 'TotalAfterTax', 'TaxCode',
	],
	paymentColumns: [
		{ name: 'U_PNRef', title: 'Trans ID' },
		{ name: 'CreateDate', title: 'Payment Date' },
		{ name: 'U_RefName', title: 'Card' },
		{ name: 'U_TransactionType', title: 'Trans Type' },
		{ name: 'U_Amount', title: 'Amount' },
		{ name: 'U_CapturedAmount', title: 'Captured Amount' },
		{ name: 'U_ParentTransID', title: 'Parent Trans ID' },
		{ name: 'U_CapturedBy', title: 'User' },
		{ name: 'U_Open', title: 'Open' },
	],
	paymentColumnOrder: [
		'U_PNRef', 'CreateDate', 'U_RefName', 'U_TransactionType', 'U_Amount', 'U_CapturedAmount',
		'U_ParentTransID', 'U_CapturedBy', 'U_Open',
	],
	sorting: [],
	grouping: [],
	expandedGroups: [],
	selection: [],
	childSelection: {},
	freightSelection: {},
	expandedRows: [],
	filters: [],
	currentPage: 0,
	pageSize: 15,
	pageSizes: [ 10, 15, 20, 50, 100 ],
	defaultCaptureType: 'A',
	captureType: {},
	selectedAuthID: {},
	loadDocsPending: false,
	refreshingOrder: false,
	showCaptureDialog: false,
	dialogOptions: {
		open: false,
		cardCode: '',
		docTable: 'ORDR',
		objType: '17',
		docEntry: '',
		type: 'authorize',
		amount: 0,
		defaultCard: '',
		referenceID: '',
	},
	dialogIndex: null,
	queuePosition: 0,
	queue: [],
};


export default ( state = initialState, action ) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };
		case types.RESET_ALL:
			return { ...initialState, ...action.newState };
		case types.RESET_PROPERTY:
			return resetProperty( state, action );
		default:
			return state;
	}
}


export const actions = {
	setState: ( data ) => ({ type: types.SET_STATE, data }),
	resetAll: ( newState = {} ) => ({ type: types.RESET_ALL, newState }),
	resetProperty: ( property ) => ({ type: types.RESET_PROPERTY, property }),

	loadOrders: ( type ) => {
		return ( dispatch, getState ) => {
			if ( !type ) type = getState().accounting.loadType;
			let reqType = type === 'withPay' ? 'listOpenOrdersWithPay' : 'listOpenOrdersWithoutPay';

			dispatch( layout.notify( 'Loading open orders...' ) );
			dispatch( {
				type: types.SET_STATE, data: {
					loadDocsPending: true,
					loadType: type,
					rows: [],
					selection: [],
					childSelection: {},
					freightSelection: {},
					expandedRows: [],
					expandedGroups: [],
				},
			} );

			svc.send( 'accounting', { method: reqType } )
				.then( res => {
					let rows = res.payload.data,
						sel = [],
						childSel = {},
						freightSel = {};

					// Pre-select everything that seems fine
					/*
					for(let i = 0; i < rows.length; i++) {
						let order = rows[i];
						let child = childSel[order.DocEntry] = [];
						let freight = freightSel[order.DocEntry] = [];

						if(!order.issues.length) {
							sel.push(i);
						}

						for(let l = 0; l < order.lines.length; l++) {
							let line = order.lines[l];
							if(line.LineStatus === 'O') {
								child.push(l);
							}
						}

						for(let l = 0; l < order.freight.length; l++) {
							let line = order.freight[l];
							if(line.Status === 'O') {
								freight.push(l);
							}
						}

					}
					*/

					dispatch( {
						type: types.SET_STATE, data: {
							rows: rows,
							loadDocsPending: false,
							childSelection: childSel,
							freightSelection: freightSel,
							selection: sel,
						},
					} );
					dispatch( layout.notify( 'Loaded orders.' ) );
				} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { loadDocsPending: false } } );
				dispatch( layout.notify( 'Error loading orders.' ) );
			} );
		};
	},


	refreshOrder: ( lineID ) => {
		return ( dispatch, getState ) => {
			let state = getState().accounting;

			if ( !state.rows[ lineID ] ) {
				dispatch( layout.notify( 'Invalid order specified.' ) );
				return false;
			}

			dispatch( layout.notify( `Refreshing data for order ${state.rows[ lineID ].DocNum}...` ) );
			dispatch( { type: types.SET_STATE, data: { refreshingOrder: true } } );

			svc.send( 'accounting', { method: 'loadOrder', docEntry: state.rows[ lineID ].DocEntry } )
				.then( res => {
					let rows = [ ...state.rows ];
					let row = res.payload.data;
					let sel = [ ...state.selection ];
					let selIndex = sel.indexOf( lineID );
					rows[ lineID ] = row;

					if ( row.issues.length && selIndex !== -1 ) {
						sel.splice( selIndex, 1 );
					}

					dispatch( {
						type: types.SET_STATE, data: {
							rows: rows,
							refreshingOrder: false,
							selection: sel,
						},
					} );
					dispatch( layout.notify( 'Successfully refreshed order!' ) );
				} ).catch( err => {
				dispatch( { type: types.SET_STATE, data: { refreshingOrder: false } } );
				dispatch( layout.notify( 'Error refreshing order.' ) );
			} );
		};
	},


	runQueue: () => {
		return ( dispatch, getState ) => {
			let state = getState().accounting;
			let sel = state.selection;
			let queue = [];

			for (let i = 0; i < sel.length; i++) {
				let queueItem = buildQueueItem( state, sel[ i ] );
				if ( queueItem ) {
					queue.push( queueItem );
				}
			}

			if ( !queue.length ) {
				dispatch( layout.notify( 'Nothing to process!' ) );
				return false;
			}

			dispatch( { type: types.SET_STATE, data: { queueIndex: 0, queue } } );
			dispatch( actions.captureOrders() );
		};
	},


	captureOrders: () => {
		return ( dispatch, getState ) => {
			let state = getState().accounting;
			let index = state.queueIndex;

			if ( state.queueIndex === state.queue.length ) {
				dispatch( layout.notify( 'Reached end of queue!' ) );
				dispatch( {
					type: types.SET_STATE, data: {
						showCaptureDialog: false,
					},
				} );
				dispatch( actions.loadOrders() );
				return false;
			}

			let { results, ...req } = state.queue[ state.queueIndex ];
			let step = 'capture';

			dispatch( layout.notify( 'Capturing payment...' ) );
			let newQueue = [ ...state.queue ];
			newQueue[ index ] = {
				...newQueue[ index ],
				results: {
					...newQueue[ index ].results,
					[ step ]: { ...newQueue[ index ][ step ], status: 'In Progress' },
				},
			};
			dispatch( {
				type: types.SET_STATE, data: {
					queue: newQueue,
					showCaptureDialog: true,
				},
			} );

			return svc.send( 'accounting', { method: 'captureOrder', ...req } ).then( res => {
				step = 'invoice';
				state = getState().accounting;
				newQueue = [ ...state.queue ];
				newQueue[ index ] = {
					...newQueue[ index ],
					results: {
						...newQueue[ index ].results,
						[ step ]: { ...newQueue[ index ][ step ], status: 'In Progress' },
						capture: { ...newQueue[ index ][ 'capture' ], status: 'Complete' },
					},
				};
				dispatch( {
					type: types.SET_STATE, data: {
						queue: newQueue,
					},
				} );

				dispatch( layout.notify( 'Creating Invoice...' ) );
				return svc.send( 'accounting', {
					method: 'makeInvoice',
					payments: res.payload.data,
					lines: req.lines,
					freight: req.freight,
					docEntry: req.DocEntry,
					header: req.header,
				} );
			} ).then( res => {
				state = getState().accounting;
				newQueue = [ ...state.queue ];
				newQueue[ index ] = {
					...newQueue[ index ],
					results: {
						...newQueue[ index ].results,
						[ step ]: { ...newQueue[ index ][ step ], status: 'Complete' },
					},
				};
				dispatch( {
					type: types.SET_STATE, data: {
						queue: newQueue,
					},
				} );

				dispatch( layout.notify( 'Invoice created successfully!' ) );
				dispatch( { type: types.SET_STATE, data: { queueIndex: state.queueIndex + 1 } } );
				dispatch( actions.captureOrders() );
			} ).catch( err => {
				state = getState().accounting;
				newQueue = [ ...state.queue ];
				newQueue[ index ] = {
					...newQueue[ index ],
					results: {
						...newQueue[ index ].results,
						[ step ]: { ...newQueue[ index ][ step ], status: 'Failed' },
					},
				};

				dispatch( {
					type: types.SET_STATE, data: {
						queue: newQueue,
					},
				} );

				dispatch( layout.notify( err.msg ) );
			} )
		};
	},


	makeDownPayment: ( rowID, payID ) => {
		return ( dispatch, getState ) => {
			let state = getState().accounting;



			dispatch( layout.notify( 'Creating down payment...' ) );

			return svc.send( 'accounting', { method: 'loadOrder', docEntry: state.rows[ rowID ].DocEntry } )
				.then( res => {
					let rows = [ ...state.rows ];
					let row = res.payload.data;
					let sel = [ ...state.selection ];
					let selIndex = sel.indexOf( rowID );
					rows[ rowID ] = row;

					if ( row.issues.length && selIndex !== -1 ) {
						sel.splice( selIndex, 1 );
					}

					dispatch( {
						type: types.SET_STATE, data: {
							rows: rows,
							refreshingOrder: false,
							selection: sel,
						},
					} );

					state = getState().accounting;
					let queue = buildQueueItem( state, rowID );
					let paymentIndex = findIndex( state.rows[ rowID ].payments, { Code: payID } );

					if ( paymentIndex === -1 ) {
						dispatch( layout.notify( 'Could not find payment reference to create down payment.' ) );
						return false;
					}

					let payment = state.rows[ rowID ].payments[ paymentIndex ];

					let req = {
						method: 'makeDownPayment',
						payments: [ { amount: payment.U_Amount, authCode: payment.U_PNRef } ],
						lines: queue.lines,
						freight: queue.freight,
						docEntry: queue.DocEntry,
						header: queue.header,
					};

					svc.send( 'accounting', { ...req } ).then( res => {
						dispatch( layout.notify( 'Down payment created successfully!' ) );
						dispatch( actions.refreshOrder( rowID ) );
					} ).catch( err => {
						dispatch( layout.notify( err.msg ) );
					} )


				} ).catch( err => {
					dispatch( { type: types.SET_STATE, data: { refreshingOrder: false } } );
					dispatch( layout.notify( 'Error refreshing order.' ) );
				} );


		};
	},
};



function resetProperty( state, action ) {
	if ( initialState.hasOwnProperty( action.property ) && isObject( initialState[ action.property ] ) ) {
		return { ...state, [ action.property ]: { ...initialState[ action.property ] } };
	}

	return state;
}



export function buildQueueItem( state, rowID ) {
	let order = state.rows[ rowID ];
	let childSel = state.childSelection[ order.DocEntry ] || [];
	let freightSel = state.freightSelection[ order.DocEntry ] || [];

	let { lines, freight, payments, issues, ...header } = order;

	if ( !order ) {
		return false;
	}

	return {
		DocEntry: order.DocEntry,
		CardCode: order.CardCode,
		header: header,
		lines: childSel.map( id => {
			return order.lines[ id ].LineNum;
		} ),
		freight: freightSel.map( id => {
			return {
				FreightCode: order.freight[ id ].FreightCode,
				LineTotal: order.freight[ id ].FreightTotal,
				TaxCode: order.freight[ id ].TaxCode,
				Key: order.freight[ id ].Key,
				LineNum: order.freight[ id ].LineNum,
			};
		} ),
		payments: order.payments.map( payment => {
			return payment.Code;
		} ),
		results: {
			capture: {
				status: 'Waiting',
				messages: [],
			},
			invoice: {
				status: 'Waiting',
				messages: [],
			},
		},
	};
}